import { FunctionComponent } from "react";
import styles from "./Radio.module.scss";
import { Radio } from "@rmwc/radio";
import "@rmwc/radio/styles";

type ownProps = {
  label: React.ReactNode;
  checked: boolean;
  name?: string;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
};

const RadioComponent: FunctionComponent<ownProps> = (props: ownProps) => {
  const { label, checked, name } = props;
  return (
    <div className={styles.CheckboxComponent}>
      <Radio
        checked={checked}
        name={name}
        onChange={(evt: React.FormEvent<HTMLInputElement>) =>
          props.onChange && props.onChange(evt)
        }
      >
        {label}
      </Radio>
    </div>
  );
};

export { RadioComponent, RadioComponent as default };
